import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from './cn.js';
export const Iskelet = forwardRef(({ className, ...rest }, ref) => (_jsx("div", { ref: ref, className: cn('bg-fume-200/70 dark:bg-fume-800/60 animate-pulse rounded-md', className), ...rest })));
Iskelet.displayName = 'Iskelet';
//# sourceMappingURL=iskelet.js.map